import type { ComponentProps } from "react";

import type { Alert } from "@vygruppen/spor-react";

type Variant = ComponentProps<typeof Alert>["variant"];

type AlertProps = {
  message: string;
  variant: Variant;
};

export class AlertError extends Error {
  readonly alerts: (AlertProps & { id: string })[];

  constructor(...alerts: AlertProps[]) {
    super(alerts.map((it) => it.message).join(", "));

    this.alerts = alerts.map((it, idx) => ({
      ...it,
      id: String(idx),
    }));
  }
}
